<!--
    描述： 六算分析表页面
    时间： xx
    created by ws
-->
<template>
	<div class="analysis-sheet-main">
		<div class="analysis-sheet-top">
			<h3 class="analysis-sheet-title"
				@click="changeBasicShow">基本信息
				<i class="ml10" :class="showBasic ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>

				<div class="fr btn-container">
					<el-button size="small"
							   type="primary"
							   class="ml10"
							   @click.stop="doExport('excel')">导出Excel</el-button>
					<el-button size="small"
							   type="primary"
							   class="ml10"
							   @click.stop="doExport('html')">导出html</el-button>
				</div>
			</h3>
			<div class="analysis-sheet-content"
				 v-show="showBasic">
				<analysis-info ref="analysisInfo"></analysis-info>
			</div>
		</div>

		<div class="analysis-sheet-bottom">
			<h3 class="analysis-sheet-title"
				@click="changeSheetShow">六算分析
				<i class="ml10" :class="showSheet ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>

				<el-select v-model="curLevel"
						   class="ml10"
						   placeholder="请选择"
						   size="small"
						   @change="onChange">
					<el-option :value="0"
							   label="展开到一级"></el-option>
					<el-option :value="1"
							   label="展开到二级"></el-option>
					<el-option :value="2"
							   label="展开到三级"></el-option>
					<el-option :value="3"
							   label="展开到四级"></el-option>
				</el-select>
			</h3>
			<div class="analysis-sheet-content"
				 v-show="showSheet">
				<analysis-list v-show="showSheet"
							   ref="analysisList"
							   @onResize="handleChange"></analysis-list>
			</div>
		</div>
	</div>
</template>

<script>
const analysisInfo = () => import('./components/analysis-sheet-info')
const analysisList = () => import('./components/analysis-sheet-list')

import { exportExcel, dateFormat } from '@/utils/tools'
// import { mapState } from 'vuex'
export default {
	name: 'analysis_home',
	components: {
		analysisInfo,
		analysisList
	},
	data() {
		return {
			activeName: ['1', '2'],
			show: true,
			showBasic: true, // 是否展示基本信息
			showSheet: true, // 是否展示表格
			curLevel: 2 // 当前展开层级
		}
	},
	methods: {
		// collapse切换事件
		handleChange(name) {
			// 看是否存在分析表
			let _exist = this.activeName.find(x => x === '2')
			this.show = false
			if (_exist) {
				setTimeout(() => {
					this.show = true
				}, 100)
				setTimeout(() => {
					this.show ? this.$refs.analysisList.setTableH() : ''
				}, 500)
			} else {
				this.show = false
			}
		},
		// 切换显示基本信息
		changeBasicShow() {
			this.showBasic = !this.showBasic

			if (this.showSheet) {
				setTimeout(() => {
					this.$refs.analysisList.setTableH()
				}, 100)
			}
		},
		// 切换展示 六算表
		changeSheetShow() {
			this.showSheet = !this.showSheet

			if (this.showSheet) {
				setTimeout(() => {
					this.$refs.analysisList.setTableH()
				}, 100)
			}
		},
		// 切换展开层级
		onChange(val) {
			if (this.$refs.analysisList) {
				this.$refs.analysisList.getMainData(val)
			}
		},

		// 点击导出
		doExport(type) {
			if (
                this.$refs.analysisList &&
                this.$refs.analysisList.tableData.length === 0
            ) {
                this.$message.info('暂时没有要导出的数据！')
                return
            }
            let saveName = '六算分析表' + dateFormat('yyyy-MM-dd hh:ss:mm')
            let params = {
            	projectId: this.curProjectId,
            	type: type,
            	base: this.$refs.analysisList.curPhase,
            	compares: ["1007001","1007002","1007003","1007004","1007005","1007006"]
            }

            exportExcel(
                'busProContract/sixCostExportExcle',
                params,
                saveName
            )
		}
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId || null
		},
	},
};
</script>

<style lang="less">
.analysis-sheet-main {
	height: 100%;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	.el-collapse {
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.list-collapse {
		flex: 1;
		display: flex;
		flex-direction: column;
		.el-collapse-item__wrap {
			flex: 1;
		}
	}
	.el-collapse-item__content {
		height: 100%;
		box-sizing: border-box;
		padding-bottom: 10px;
	}

	.analysis-sheet-bottom {
		flex: 1;
		overflow: auto;

		.analysis-sheet-content {
			height: calc(~'100% - 45px');
		}
	}

	.analysis-sheet-title {
		height: 45px;
		line-height: 45px;
		background-color: #fff;
		padding-left: 10px;
		font-size: 16px;
		font-weight: 700;
		cursor: pointer;
		border-bottom: 1px solid #ccc;

		.btn-container {
			display: flex;
			align-items: center;
			height: 100%;
			padding-right: 10px;
		}
	}

	.analysis-sheet-content {
		padding: 10px;
		box-sizing: border-box;
	}

	.el-table {
		.project-row {
			td {
				background-color: #a5ddfd;
			}
		}

		.single-row {
			td {
				background-color: #bce3fb;
			}
		}

		.unit-row {
			td {
				background-color: #ceebfb;
			}
		}
	}
}
</style>
